import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Solutions } from "./components/solutions";
import { Equipment } from "./components/equipment";
import { CTA } from "./components/cta";
import { Footer } from "./components/footer";
import { ContactProvider } from "./components/ContactContext";
import { CarwashPage } from "./pages/CarwashPage";
import { ParkingPage } from "./pages/ParkingPage";
import { JoinPage } from "./pages/JoinPage";
import { PromoScanPage } from "./pages/PromoScanPage";
import SmoothScroll from "smooth-scroll";
import "./App.css";

// Al cambiar de página sube al inicio; si el enlace trae #seccion (ej. /#solutions
// desde otra página), baja a esa sección cuando ya está montada.
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) { window.scrollTo(0, 0); return; }
    const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" }), 80);
    return () => clearTimeout(t);
  }, [pathname, hash]);
  return null;
};

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const HomePage = () => (
  <div>
    <Navigation />
    <Header />
    <Solutions />
    {/*<Equipment /> */}
    <CTA />
    <Footer />
  </div>
);

const App = () => {
  return (
    <div style={{ overflowX: "hidden", width: "100%" }}>
      <BrowserRouter>
        <ScrollToTop />
        <ContactProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/industries/car-wash" element={<CarwashPage />} />
          <Route path="/industries/parking" element={<ParkingPage />} />
          <Route path="/join" element={<JoinPage />} />
          <Route path="/promo-scan" element={<PromoScanPage />} />
        </Routes>
        </ContactProvider>
      </BrowserRouter>
    </div>
  );
};

export default App;